<template>
  <div>
    <v-row>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Assign Head User</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      :items="users"
                      label="Select User"
                      v-model="user"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveHeadUser">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from 'sweetalert2';

export default {
  name: "OfficeAssignHead",
  props: {
    dialog: Boolean,
    users: Array,
    office: Object,
  },
  data() {
    return {
      user: null,
      selected_office: null,
      errorMessage: null,
    };
  },
  methods: {
    ...mapActions(['fetchUsers', 'updateHeadUser']),
    close() {
        this.user = null;
        this.errorMessage = null;
        this.$emit('closeDialog', false);
    },
    async saveHeadUser() {
        let save = await this.updateHeadUser({ user: this.user, office: this.selected_office });
        
        if(save.error) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Internal Server Error',
            })
        } else {
            this.close();
        }
    },
  },
  computed: mapGetters(["allUsers"]),
  watch: {
      users: function () {

      },
      office: function () {
          if(this.office) this.selected_office = this.office;
      }
  },
  created() {
    // this.fetchUsers();
  }
};
</script>

<style>
</style>